module.exports = __webpack_public_path__ + "static/illustrazione-capitolo-2-6fc4a2dd50426f7cd4c5f58bba928c40.svg";